import { takeEvery, put, call, all, Effect, takeLatest } from "redux-saga/effects";

import { userSlice } from "../reducer/user";
import { AxiosResponse } from "axios";
import { returnsApi } from "../../api/ReturnsApi";
import { returnsSlice } from "../reducer/returns";
import { ReturnSummary } from "../../model/tax/tax_return";
import { FetchReturnsTask } from "../../utils/tasks";

function* fetchReturnsSaga(): Generator<Effect, void, any> {
    yield put(returnsSlice.actions.addTask(FetchReturnsTask));
    try {
        const response = (yield call(returnsApi.getTaxReturns)) as AxiosResponse<ReturnSummary[]>;
        yield put(returnsSlice.actions.setReturns(response.data));
    } catch (error: any) {
        yield put(userSlice.actions.fetchUserError(error.message));
    } finally {
        yield put(returnsSlice.actions.removeTask(FetchReturnsTask.id));
    }

}
export default function* returnsSaga() {
  yield all([takeLatest(returnsSlice.actions.fetchReturnsRequest.type, fetchReturnsSaga)]);
}
